import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import { DialogTitle, DialogTitleProps } from 'components/Dialog';
import { TypographyProps } from 'components/Typography';

const TYPOGRAPHY_CONFIG = {
  variant: 'TITLE_16',
  style: {
    flex: 1,
  }
};

export interface DialogSheetTitleProps extends DialogTitleProps {
  /** The content of the title. */
  title: React.ReactNode;
  /** The title typography props. */
  typographyProps?: Partial<TypographyProps>;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/**
 * All other props will be provided to the wrapper element.
 * See DialogTitle documentation for additional props information
 */
const DialogSheetTitle = React.forwardRef<HTMLDivElement, DialogSheetTitleProps>((props: DialogSheetTitleProps, ref) => getContext(({ theme }) => {
  const {
    title,
    typographyProps: givenTypographyProps,
    theme: themeProp,
    ...otherProps
  } = props;

  const resolvedTheme = _merge({}, theme ? theme.DIALOG_SHEET : {}, themeProp);

  const typographyProps = _merge(
    {}, {
      style: {
        color: resolvedTheme.title,
      },
    },
    TYPOGRAPHY_CONFIG,
    givenTypographyProps
  );

  return (
    <DialogTitle
      title={title}
      ref={ref}
      typographyProps={typographyProps}
      {...otherProps}
    />
  );
}));

DialogSheetTitle.defaultProps = {
  typographyProps: {},
  theme: {}
};
DialogSheetTitle.displayName = 'DialogSheetTitle';

export default DialogSheetTitle;
